module.exports = __webpack_public_path__ + "img/f5e7d07.png";